// Single source of truth for the practice's name, address, phone, hours, and
// languages. Rendered on pages and in JSON-LD so they never disagree.
// CommonJS so the Node build scripts can require it too.

const SITE_URL = "https://bensondentalstudio.com";

const business = {
  name: "Benson Dental Studio",
  url: SITE_URL,
  phone: "718-266-5889",
  phoneE164: "+1-718-266-5889",
  email: "hello@bensondentalstudio.com",
  address: {
    street: "2260 Benson Ave",
    city: "Brooklyn",
    state: "NY",
    zip: "11214",
    neighborhood: "Bensonhurst",
    crossStreet: "23rd Ave",
  },
  geo: { latitude: 40.598944, longitude: -73.996551 },
  mapsUrl: "https://maps.google.com/?cid=11364746045686772304",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3029.402415236151!2d-73.99655082373867!3d40.59894424452882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c245d72ff72ddd%3A0x9db7b050c7af7250!2sBenson%20Dental%20Studio!5e0!3m2!1sen!2sus!4v1721970436808!5m2!1sen!2sus",
  instagramUrl: "https://www.instagram.com/benson_dental_studio/",
  languages: ["English", "Russian", "Ukrainian"],
  languageCodes: ["en", "ru", "uk"],
  // Display rows for the hours table. `days` uses schema.org day names.
  hours: [
    { label: "Tuesday, Wednesday, Thursday", short: "Tue - Thu", days: ["Tuesday", "Wednesday", "Thursday"], opens: "09:00", closes: "17:00", display: "9 AM - 5 PM" },
    { label: "Friday", short: "Fri", days: ["Friday"], opens: "09:00", closes: "14:00", display: "9 AM - 2 PM" },
    { label: "Saturday, Sunday, Monday", short: "Sat - Mon", days: ["Saturday", "Sunday", "Monday"], closed: true, display: "Closed" },
  ],
  hoursSummary: "Tuesday through Thursday 9 AM to 5 PM, and Friday 9 AM to 2 PM. We are closed Saturday, Sunday, and Monday",
  areasServed: ["Bensonhurst", "Sheepshead Bay", "Bay Ridge", "Gravesend", "Bath Beach", "Dyker Heights", "South Brooklyn"],
  zipsServed: ["11214", "11204", "11209", "11223", "11228", "11229", "11235"],
  dentist: {
    name: "Alina Draganchyuk Aga, DDS",
    shortName: "Dr. Alina",
    jobTitle: "General & Cosmetic Dentist",
    image: "/imgs/dr-alina.webp",
  },
};

const fullAddress = `${business.address.street}, ${business.address.city}, ${business.address.state} ${business.address.zip}`;

const DENTIST_ID = `${SITE_URL}/#dentist`;

const buildDentistJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "Dentist",
  "@id": DENTIST_ID,
  name: business.name,
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/logo512.png`,
  image: [`${SITE_URL}/og-image.jpg`, `${SITE_URL}/imgs/gallery/office/office-exterior.webp`],
  telephone: business.phoneE164,
  email: business.email,
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: business.address.street,
    addressLocality: business.address.city,
    addressRegion: business.address.state,
    postalCode: business.address.zip,
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: business.geo.latitude,
    longitude: business.geo.longitude,
  },
  hasMap: business.mapsUrl,
  openingHoursSpecification: business.hours
    .filter((h) => !h.closed)
    .map((h) => ({
      "@type": "OpeningHoursSpecification",
      dayOfWeek: h.days,
      opens: h.opens,
      closes: h.closes,
    })),
  knowsLanguage: business.languageCodes,
  areaServed: [
    ...business.areasServed.map((name) => ({ "@type": "Place", name: `${name}, Brooklyn, NY` })),
    ...business.zipsServed.map((postalCode) => ({ "@type": "PostalAddress", postalCode, addressRegion: "NY", addressCountry: "US" })),
  ],
  medicalSpecialty: "Dentistry",
  employee: {
    "@type": "Person",
    name: business.dentist.name,
    jobTitle: business.dentist.jobTitle,
    image: `${SITE_URL}${business.dentist.image}`,
    alumniOf: { "@type": "CollegeOrUniversity", name: "NYU College of Dentistry" },
    knowsLanguage: business.languageCodes,
    memberOf: [
      { "@type": "Organization", name: "American Dental Association" },
      { "@type": "Organization", name: "New York State Dental Association" },
    ],
  },
  sameAs: [business.mapsUrl, business.instagramUrl],
});

const buildBreadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

module.exports = {
  SITE_URL,
  DENTIST_ID,
  business,
  fullAddress,
  buildDentistJsonLd,
  buildBreadcrumbJsonLd,
};
